import 'firepuma-vue-axios-vuex-extensions/vue-polyfills/polyfill';

import config from '@/config';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { appInsights, initializeAppInsights } from './plugins/appInsights'
import App from '@/App'
import { Router } from '@/router';
import { Store as store } from '@/store'

import * as filters from 'firepuma-vue-axios-vuex-extensions/vue-filters';
import directivesConfig from 'firepuma-vue-axios-vuex-extensions/vue-directives/config';
import * as directives from 'firepuma-vue-axios-vuex-extensions/vue-directives/index';
import * as mixins from 'firepuma-vue-axios-vuex-extensions/vue-mixins';
import apiBaseConfig from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBaseConfig';

import 'jquery';
import 'popper.js';
import 'bootstrap';
import BootstrapVue from 'bootstrap-vue';

import 'font-awesome/css/font-awesome.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css';

import '@/assets/styles/css3-flex-layout.css';
import '@/assets/styles/theme.scss'
import '@/assets/styles/transitions.css'

import Navbar from '@/Navbar.vue'
import AxiosApiLoader from '@/AxiosApiLoader.vue'
import AxiosApiForm from '@/AxiosApiForm.vue'
import AxiosApiButton from '@/AxiosApiButton.vue'
import AxiosApiTrigger from '@/AxiosApiTrigger.vue'
import VueConfirmClick from '@/VueConfirmClick.vue'

initializeAppInsights()

directivesConfig.AppName = config.AppName;
apiBaseConfig.ApiBaseUrl = config.ApiBaseUrl;
apiBaseConfig.Store = store;

Vue.use(BootstrapVue);

Vue.component('default-navbar', Navbar);
Vue.component('api-loader', AxiosApiLoader);
Vue.component('api-form', AxiosApiForm);
Vue.component('api-button', AxiosApiButton);
Vue.component('api-trigger', AxiosApiTrigger);
Vue.component('confirm-click', VueConfirmClick);

Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
});

Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: Router,
  store,
  components: {
    App
  },
  template: '<App/>'
})

let setTelemetryData = () => { }
var telemetryInitializer = (envelope) => {
  setTelemetryData(envelope.data)
};
appInsights.addTelemetryInitializer(telemetryInitializer);



// WEBPACK FOOTER //
// ./src/main.js